var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"other-materials",class:_vm.item.theme ? 'other-materials_' + _vm.item.theme : 'other-materials_dark',on:{"click":function($event){_vm.blockClick(
      _vm.item.title,
      _vm.helpers.buildRoute(
        _vm.item.route || {
          name: 'SuccessAcademySections',
          params: { slug: _vm.item.slug },
        }
      )
    )}}},[_c('div',{staticClass:"other-materials__generate _pa-8"},[_c('div',{staticClass:"other-materials__text"},[_c('h3',{staticClass:"other-materials__title _fs-20 _lh-24 _fw-700",domProps:{"innerHTML":_vm._s(_vm.item.title)}}),_c('div',{staticClass:"other-materials__descr _fs-16 _lh-24 _mt-2",domProps:{"innerHTML":_vm._s(_vm.item.descr)}})]),_c('img',{staticClass:"other-materials__img",attrs:{"src":_vm.item.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }